"use strict";
exports.__esModule = true;
require('./card.css');
exports.default = {
  "card": "pf-v5-c-card",
  "cardActions": "pf-v5-c-card__actions",
  "cardBody": "pf-v5-c-card__body",
  "cardExpandableContent": "pf-v5-c-card__expandable-content",
  "cardFooter": "pf-v5-c-card__footer",
  "cardHeader": "pf-v5-c-card__header",
  "cardHeaderMain": "pf-v5-c-card__header-main",
  "cardHeaderToggle": "pf-v5-c-card__header-toggle",
  "cardHeaderToggleIcon": "pf-v5-c-card__header-toggle-icon",
  "cardSelectableActions": "pf-v5-c-card__selectable-actions",
  "cardSrInput": "pf-v5-c-card__sr-input",
  "cardTitle": "pf-v5-c-card__title",
  "cardTitleText": "pf-v5-c-card__title-text",
  "checkInput": "pf-v5-c-check__input",
  "checkLabel": "pf-v5-c-check__label",
  "divider": "pf-v5-c-divider",
  "modifiers": {
    "selectable": "pf-m-selectable",
    "clickable": "pf-m-clickable",
    "selected": "pf-m-selected",
    "current": "pf-m-current",
    "disabled": "pf-m-disabled",
    "hoverableRaised": "pf-m-hoverable-raised",
    "selectableRaised": "pf-m-selectable-raised",
    "nonSelectableRaised": "pf-m-non-selectable-raised",
    "selectedRaised": "pf-m-selected-raised",
    "compact": "pf-m-compact",
    "displayLg": "pf-m-display-lg",
    "flat": "pf-m-flat",
    "plain": "pf-m-plain",
    "rounded": "pf-m-rounded",
    "expanded": "pf-m-expanded",
    "fullHeight": "pf-m-full-height",
    "toggleRight": "pf-m-toggle-right",
    "noOffset": "pf-m-no-offset",
    "noFill": "pf-m-no-fill"
  },
  "radioInput": "pf-v5-c-radio__input",
  "radioLabel": "pf-v5-c-radio__label",
  "themeDark": "pf-v5-theme-dark"
};